const initialState = {
    siteDetails: {},
    floorsList: [],
    totalFloorsCount: 0,
};

const floorReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FLOOR_LIST': {
            return {
                ...state,
                siteDetails: action.payload.siteDetails,
                floorsList: action.payload.floors,
                totalFloorsCount: action.payload.totalCount,
            };
        }
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default floorReducer;